import {
  NotificationContentType,
  NotificationType,
} from '@/features/notifications/notification-types';
import AddPersonIcon from '@/shared/assets/add_person.svg?react';
import AlertIcon from '@/shared/assets/alert.svg?react';
import CalendarIcon from '@/shared/assets/calendar.svg?react';
import InfoIcon from '@/shared/assets/info.svg?react';

export const NotificationIcon = ({
  type,
  contentType,
}: {
  type: NotificationType;
  contentType: NotificationContentType;
}) => {
  switch (type) {
    case NotificationType.alert:
      return <AlertIcon />;
    case NotificationType.info:
      return <InfoIcon />;
    case NotificationType.custom:
      switch (contentType) {
        case NotificationContentType.new_org_member:
        case NotificationContentType.new_project_member:
        case NotificationContentType.contractor_invitation_accepted:
        case NotificationContentType.contractor_invitation:
          return <AddPersonIcon />;
        case NotificationContentType.project_end_hint:
          return <CalendarIcon />;
        default:
          return <InfoIcon />;
      }
    default:
      return <InfoIcon />;
  }
};
